module.exports = __webpack_public_path__ + "assets/filter-new-e9b1c5.svg";